module.exports = __webpack_public_path__ + "img/full4-min.cda43d93.png";